import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GizLibraryModule } from "../giz-library/giz-library.module";
import { InicioViewComponent } from "./inicio/inicio-view/inicio-view.component";
import { CatalogoViewComponent } from "./catalogo/catalogo-view/catalogo-view.component";
import { NosotrosViewComponent } from "./nosotros/nosotros-view/nosotros-view.component";
import { PublicacionesViewComponent } from "./publicaciones/publicaciones-view/publicaciones-view.component";
import { AppmovilViewComponent } from "./appmovil/appmovil-view/appmovil-view.component";
import { ContactoViewComponent } from "./contacto/contacto-view/contacto-view.component";
import { CatalogoItemViewComponent } from "./catalogo-item/catalogo-item-view/catalogo-item-view.component";
import { BreadcrumbComponent } from "./widget/breadcrumb/breadcrumb.component";
import { NotificationComponent } from "./widget/notification/notification.component";
import { SignInViewComponent } from "./sign-in/sign-in-view/sign-in-view.component";
import { SignUpViewComponent } from "./sign-up/sign-up-view/sign-up-view.component";
import { GuardianesViewComponent } from "./guardianes/guardianes-view/guardianes-view.component";
import { ComunidadesViewComponent } from "./comunidades/comunidades-view/comunidades-view.component";
import { GuardianesItemViewComponent } from "./guardianes-item/guardianes-item-view/guardianes-item-view.component";
import { CatalogoSearchViewComponent } from "./catalogo-search/catalogo-search-view/catalogo-search-view.component";
import { ExplorerViewComponent } from "./explorer/explorer-view/explorer-view.component";
import { ExplorerItemViewComponent } from "./explorer-item/explorer-item-view/explorer-item-view.component";
import { CatalogoInfoViewComponent } from "./catalogo-info/catalogo-info-view/catalogo-info-view.component";
import { NgcCookieConsentModule } from "ngx-cookieconsent";
import { PolicyAViewComponent } from "./policy-a/policy-a-view/policy-a-view.component";
import { PolicyBViewComponent } from "./policy-b/policy-b-view/policy-b-view.component";
import { PolicyCViewComponent } from "./policy-c/policy-c-view/policy-c-view.component";
import { ExplorationManagementViewComponent } from "./exploration-management/exploration-management-view/exploration-management-view.component";
import { ConsumeMiskiPapaViewComponent } from "./consume-miski-papa/consume-miski-papa-view/consume-miski-papa-view.component";
import { RegistraVariedadesViewComponent } from "./registra-variedades/registra-variedades-view/registra-variedades-view.component";
import { ProfileViewComponent } from "./profile/profile-view/profile-view.component";
import { CatalogoImportViewComponent } from "./catalogo-import/catalogo-import-view/catalogo-import-view.component";
import { ExplorerImportViewComponent } from "./explorer-import/explorer-import-view/explorer-import-view.component";
import { CatalogoListViewComponent } from "./catalogo-list/catalogo-list-view/catalogo-list-view.component";
import { CatalogoItemEditViewComponent } from "./catalogo-item-edit/catalogo-item-edit-view/catalogo-item-edit-view.component";
import { CatalogoItemNewViewComponent } from "./catalogo-item-new/catalogo-item-new-view/catalogo-item-new-view.component";
import { ExplorerItemEditViewComponent } from "./explorer-item-edit/explorer-item-edit-view/explorer-item-edit-view.component";
import { ExplorerItemNewViewComponent } from "./explorer-item-new/explorer-item-new-view/explorer-item-new-view.component";
import { ExplorerItemFavoritesViewComponent } from "./explorer-item-favorites/explorer-item-favorites-view/explorer-item-favorites-view.component";
import { ConfigurarCuentaViewComponent } from "./configurar-cuenta/configurar-cuenta-view/configurar-cuenta-view.component";
import { TableroViewComponent } from "./tablero/tablero-view/tablero-view.component";
import { HomeViewComponent } from "./home/home-view/home-view.component";
import { ExplorerListEditViewComponent } from "./explorer-list-edit/explorer-list-edit-view/explorer-list-edit-view.component";
import { CatalogoListEditViewComponent } from "./catalogo-list-edit/catalogo-list-edit-view/catalogo-list-edit-view.component";
import { FavoritesViewComponent } from "./favorites/favorites-view/favorites-view.component";
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { QrListViewComponent } from './qr-list/qr-list-view/qr-list-view.component';
import { ErrorViewComponent } from './error/error-view/error-view.component';

@NgModule({
  imports: [
    CommonModule,
    GizLibraryModule,
    NgcCookieConsentModule,
    LeafletModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [
    InicioViewComponent,
    CatalogoViewComponent,
    NosotrosViewComponent,
    PublicacionesViewComponent,
    AppmovilViewComponent,
    ContactoViewComponent,
    CatalogoItemViewComponent,
    BreadcrumbComponent,
    NotificationComponent,
    SignInViewComponent,
    SignUpViewComponent,
    GuardianesViewComponent,
    ComunidadesViewComponent,
    GuardianesItemViewComponent,
    CatalogoSearchViewComponent,
    ExplorerViewComponent,
    ExplorerItemViewComponent,
    CatalogoInfoViewComponent,
    PolicyAViewComponent,
    PolicyBViewComponent,
    PolicyCViewComponent,
    ExplorationManagementViewComponent,
    ConsumeMiskiPapaViewComponent,
    RegistraVariedadesViewComponent,
    ProfileViewComponent,
    CatalogoImportViewComponent,
    ExplorerImportViewComponent,
    CatalogoListViewComponent,
    CatalogoItemEditViewComponent,
    CatalogoItemNewViewComponent,
    ExplorerItemEditViewComponent,
    ExplorerItemNewViewComponent,
    ExplorerItemFavoritesViewComponent,
    ConfigurarCuentaViewComponent,
    TableroViewComponent,
    HomeViewComponent,
    ExplorerListEditViewComponent,
    CatalogoListEditViewComponent,
    FavoritesViewComponent,
    QrListViewComponent,
    ErrorViewComponent,
  ],
  exports: [],
})
export class GizLayoutModule { }
